module.exports = __webpack_public_path__ + "img/friend3.d4325f1f.png";